import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import LabeledRadio from 'admin/components/molecules/LabeledRadio';

const FormWrapper = styled.div`
  ${LabeledRadio} {
    display: inline;
  }
`;

const RadioOptions = ({
  id, options, onChangeQuery, isClear, initialOption,
}) => {
  const [radioOptions, setRadioOptions] = useState(
    options.map((option) =>
      option.value === initialOption ? { ...option, checked: true } : { ...option, checked: false }
    )
  );

  useEffect(() => {
    if (isClear) {
      setRadioOptions(radioOptions.map(option => (
        Object.assign(option, { checked: false })
      )));
      onChangeQuery(id, null);
    }
  }, [isClear]);

  const handleClick = (e, option) => {
    e.preventDefault();
    setRadioOptions(radioOptions.map(element => (
      element === option
        ? Object.assign(element, { checked: true })
        : Object.assign(element, { checked: false })
    )));
    onChangeQuery(id, option.value);
  };

  const rows = radioOptions.map(option => (
    <LabeledRadio
      key={`option-${Math.random()}`}
      labelText={option.label}
      checked={option.checked}
      onChange={e => handleClick(e, option)}
    />
  ));

  return (
    <FormWrapper>
      {rows}
    </FormWrapper>
  );
};

RadioOptions.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onChangeQuery: PropTypes.func.isRequired,
  isClear: PropTypes.bool.isRequired,
};

export default RadioOptions;
